
import Log from '../Log';
import OneSignal, { ResourceLoadState } from "../types/OneSignal";
import { PromptOptions } from "./types";
import Prompt from './Prompt';
import { InStockAlertSettings } from '../settings';
import { delay } from "./utils";
import { IN_STOCK_STYLES, IN_STOCK_PROMPT_CLASS, PROMPT_AUTOCLOSE_DELAY, CONFIRMATION_STYLES, CONFIRMATION_PROMPT_CLASS } from "./constants";

export default class PromptManager {
  public static async createInStockPrompt(
    inStockSettings: InStockAlertSettings,
    onAllow?: () => void,
    onCancel?: () => void,
  ): Promise<void> {
    await this.showSlideDownPrompt({
      messageText: inStockSettings.prompt_message,
      allowButtonText: inStockSettings.accept_button,
      cancelButtonText: inStockSettings.cancel_button,
      delay: inStockSettings.time_delay,
      customCssStyle: IN_STOCK_STYLES,
      promptContainerClass: IN_STOCK_PROMPT_CLASS,
      onAllow,
      onCancel,
    });
  }

  public static async createConfirmationPrompt(messageText: string): Promise<void> {
    await this.showSlideDownPrompt({
      messageText,
      customCssStyle: CONFIRMATION_STYLES,
      promptContainerClass: CONFIRMATION_PROMPT_CLASS,
      autoCloseDelay: PROMPT_AUTOCLOSE_DELAY,
    });
  }

  private static async showSlideDownPrompt(promptOptions: PromptOptions): Promise<void> {
    // Delay prompt appearance if the time_delay value is set in the settings
    if (promptOptions.delay && promptOptions.delay > 0) {
      await delay(promptOptions.delay);
    }

    // Load the default prompt stylesheets
    const sdkStylesLoadResult: ResourceLoadState =
      await (window.OneSignal as OneSignal).context.dynamicResourceLoader.loadSdkStylesheet();

    if (sdkStylesLoadResult !== ResourceLoadState.Loaded) {
      Log.debug('Not showing slidedown because styles failed to load.');
      return;
    }

    // Create a prompt instance with the given options and display it
    const prompt = new Prompt(promptOptions);
    prompt.display();
    Log.debug('Showing Slidedown.');

    // Set a delay after displaying the prompt and trigger the auto close if value is set
    if (promptOptions.autoCloseDelay && promptOptions.autoCloseDelay > 0) {
      await delay(promptOptions.autoCloseDelay);
      prompt.close();
    }
  }
}
